module.exports = __webpack_public_path__ + "static/UI_and_UX_Design-ed407d499a9425272407abd966882ba5.svg";